/**
 * name 热点关联散点图
 * author zhang.yingyu
 * createTime 2019-04-01
 */
angular.module('hotAtlasRelationChartModule', ["hotARCServiceModule"])
    .directive('hotAtlasRelationChartDir', ['$q', 'hotARCService', '$timeout', 'trsHttpService', function($q, hotARCService, $timeout, trsHttpService) {
        return {
            restrict: 'E',
            replace: true,
            template: "<div ng-style=\"myStyle\" ng-click=\"request(params)\"></div>",
            scope: {
                options: "=",
            },
            link: function($scope, iElement, iAttrs) {
                $timeout(function() {
                    $scope.myStyle = {
                        height: '100%',
                        width: '100%'
                    };
                    var datasArr=[],linksArr=[],initCenterData,layout,
                        forceData={
                            gravity: 0.02,
                            layoutAnimation: true,
                        },
                        myChart,optionConfig={},
                        legend =[
                        {name:"关键词"},
                        {name:"机构实体"},
                        {name:"人物实体"},
                    ];
                    $scope.$watch("options",function(newData,oldData){
                        if(!$scope.options.relateData){$scope.options.relateData=[];}
                        if (myChart != null && myChart != "" && myChart != undefined) {
                            myChart.dispose();
                        }
                        $scope.options.keywords=getInitKeywords($scope.options.keywords,"关键词");
                        $scope.options.org=getInitKeywords($scope.options.org,"机构实体");
                        $scope.options.name=getInitKeywords($scope.options.name,"人物实体");
                        var  keywords=$scope.options.keywords.concat($scope.options.org).concat($scope.options.name);
                        datasArr=[],linksArr=[];
                        if($scope.options.relateData.length>1){
                            initCenterData=$scope.options.relateData;
                            layout="circular";
                        }else{
                            initCenterData=$scope.options.title;
                            layout="force";
                        }
                        getData(keywords, initCenterData,$scope.options.source);
                        getLinksData(keywords,initCenterData,$scope.options.source);
                        datasArr = hotARCService.textWrap(datasArr);
                        if($scope.options.relateData.length>1){
                            forceData.repulsion=120;
                            forceData.edgeLength=70;
                        }else{
                            forceData.repulsion=Math.ceil(datasArr.length/5)*30;//子节点之间的间距
                            forceData.edgeLength=Math.ceil(datasArr.length/5)*10;//连线的长度
                        }
                        optionConfig = {
                            legend:[{
                                data:legend,
                                icon: 'circle',
                                type: 'scroll',
                                orient: 'horizontal',
                                bottom:0,
                            }],
                            animationDurationUpdate: 1500,
                            animationEasingUpdate: 'quinticInOut',
                            series: [{
                                type: 'graph',
                                layout:layout,
                                force:forceData,
                                roam: true,
                                draggable: true,
                                label: {
                                    normal: {
                                        show: true,
                                        textStyle: {
                                            color: "#fff",
                                            fontSize: 14,
                                            rotate: true,
                                        },
                                    }
                                },
                                edgeSymbol: ['circle', 'arrow'],
                                edgeSymbolSize: [4, 10],
                                edgeLabel: {
                                    normal: {
                                        textStyle: {
                                            fontSize: 20,
                                        }
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        shadowColor: 'rgba(85,167,253,0.9)',
                                        shadowBlur: 10
                                    }
                                },
                                categories:legend,
                                data: datasArr,
                                links: linksArr,
                                lineStyle: {
                                    normal: {
                                        color: '#BAD2E9',
                                        opacity: 0.9,
                                        width: 2,
                                        curveness: 0,
                                        type: 'dotted',
                                    }
                                }
                            }],
                            color: ['#47B2AD', '#5B9BDB', '#E8941C']
                        };
                        initChart();
                    },true);
                    /**
                     * [initChart description] 初始化echart
                     * @return {[type]} [description]
                     */
                    function initChart(){
                        require(['echarts'], function (echarts) {
                            myChart = echarts.init(iElement[0]);
                            myChart.setOption(optionConfig);
                            myChart.getOption();
                            window.addEventListener("resize", function () {
                                myChart.resize();
                            });
                            myChart.on("click", function (params) {
                                var tranDatas = params.data;
                                $scope.$emit('getRelateChartData', {tranDatas: tranDatas});
                            });
                        });
                    };
                    /**
                     * [getInitKeywords description] 初始化关键词
                     * @return {[type]} [description]
                     */
                    function getInitKeywords(data,type){
                        if(data&&typeof data==="string")   data=data.split(";");
                        if(data&&Object.prototype.toString.call(data[0])==="[object String]"){
                            data=data.map(function(item,index){
                                var obj={
                                    id:item+type+index,
                                    name:item,
                                    category:type
                                };
                                return obj;
                            });
                        }else{
                            data=data;
                        }
                        return data;
                    };
                    /**
                     * [getLinksData description] 获取连接数据
                     * @return {[type]} [description]
                     */
                    function getLinksData(data, centerData,source) {
                        if(centerData.length>1&&angular.isArray(centerData)){
                            for (var i = 0; i < data.length; i++) {
                                if (!!data[i]) {
                                    for(var j=0;j<centerData.length;j++){
                                        var obj = {
                                            source:centerData[j].ID+centerData[j].TASKID,
                                            target: data[i].id,
                                        };
                                        linksArr.push(obj);
                                    }
                                    linksArr.push({
                                        source:source,
                                        target: data[i].id,
                                    });
                                }
                            }
                        }else{
                            for (var i = 0; i < data.length; i++) {
                                if(!!data[i]){
                                    var obj = {
                                        source: centerData,
                                        target: data[i].id,
                                    };
                                    linksArr.push(obj);
                                }
                            }
                        }
                        return linksArr;
                    };
                    /**
                     * [getData description] 获取当前数据
                     * @return {[type]} [description]
                     */
                    function getData(data, centerData,source) {
                        for (var i = 0; i < data.length; i++) {
                            if (!!data[i]) {
                                var obj = {
                                    x: i * 10,
                                    y: 20 + i * 10,
                                    id:data[i].id,
                                    category:data[i].category,
                                    showName: data[i].name,
                                    name: data[i].name,
                                    symbolSize: 50,
                                };
                                datasArr.push(obj);
                            }
                        }
                        if(centerData.length>1&&angular.isArray(centerData)){
                            datasArr.push({
                                x: 0,
                                y: 0,
                                name: source,
                                symbolSize: 110,
                                itemStyle: {
                                    normal: {
                                        color: '#f76280',
                                    }
                                },
                            });
                            for(var i=0;i<centerData.length;i++){
                                datasArr.push({
                                    x: i * 60,
                                    y:60 + i * 10,
                                    taskId:centerData[i].ID,
                                    id:centerData[i].ID+centerData[i].TASKID,
                                    name: centerData[i].TITLE,
                                    symbolSize: 110,
                                    itemStyle:{
                                        normal:{
                                            color:'#71C276',
                                        },
                                    },
                                });
                            }
                        }else{
                            datasArr.push({
                                x: 0,
                                y: 0,
                                name: centerData,
                                symbolSize: 160,
                                itemStyle: {
                                    normal: {
                                        color: '#d64541',
                                    }
                                },
                            });
                        }
                        return datasArr;
                    };
                }, 500);
            }
        };
    }]);